// @ts-nocheck
import React from "react";
import InfoPageLayout, { InfoSection, InfoList } from "../components/InfoPageLayout";

export default function WhatIsCardex() {
  return (
    <InfoPageLayout
      title="What is Cardex?"
      subtitle="A privacy-first platform for local, in-person trading."
      updated="February 7, 2026"
    >
      <InfoSection title="Local, In-Person Trading">
        <p>
          Cardex helps collectors discover nearby traders and coordinate safe, in-person meetups.
        </p>
        <InfoList items={[
          "No payments processed through the platform",
          "No shipping or delivery services",
          "All trades happen face-to-face",
          "Meet in public places for safety"
        ]} />
      </InfoSection>

      <InfoSection title="Privacy-First by Design">
        <p>
          Your personal information is protected and never shared with other users.
        </p>
        <InfoList items={[
          "Email addresses remain private",
          "Phone numbers are never shared",
          "Location data is not disclosed",
          "Only your public trading profile is visible"
        ]} />
      </InfoSection>

      <InfoSection title="Safety Comes First">
        <p>
          We prioritize community safety with built-in protections and guidelines.
        </p>
        <InfoList items={[
          "18+ age verification required",
          "3-strike trust system for violations",
          "In-app reporting for suspicious behavior",
          "Zero-tolerance for counterfeit cards"
        ]} />
      </InfoSection>

      <InfoSection>
        <p className="info-contact">Questions? Reach us at support@cardexhq.com</p>
      </InfoSection>
    </InfoPageLayout>
  );
}
